import React, { useEffect } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { makeStyles, Theme } from "@material-ui/core/styles"

import { Status } from "shared/types/status"
import { RootState } from "../../redux/store"
import useAppState from "hooksV1/useAppState"
import { Project } from "shared/types/project"
import { containsPathProjectHome } from "util/helper"
import SideNaveV1 from "components/SideNav/SideNaveV1"
import DocumentsToolBar from "components/DocumentsToolBar"
import { fetchProjectsByUserV2 } from "redux/thunks/projectsThunk"

const useStyles = makeStyles((theme: Theme) => ({
  main: {
    flexGrow: 1,
    padding: "0.75rem",
  },
  root: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  container: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    marginTop: "0.75rem",
  },
  sideNav: {
    width: "15%",
    height: "100%",
  },
  body: {
    flex: 1,
    height: "100%",
  },
}))

const ProjectHomeV1: React.FC = () => {
  const classes = useStyles()
  let navigate = useNavigate()
  const dispatch = useDispatch()
  const { activeCountry, setActiveProject, setActiveProjectUser } =
    useAppState()

  const projects: Project[] = useSelector(
    (state: RootState) => state.projects.projects
  )

  const validatedUser = useSelector(
    (state: RootState) => state.authorisation.user
  )

  const projectStatus = useSelector(
    (state: RootState) => state.projects.getProjectStatus
  )

  const pathArray = location.pathname.split("/")
  const projectId = pathArray[2]

  useEffect(() => {
    if (projects.length > 0) {
      const activeProject = projects.find((project) => project.id === projectId)

      setActiveProject(activeProject)

      const activeUser = activeProject?.users.find(
        (user) => user.user.id === validatedUser?.id
      )

      setActiveProjectUser(activeUser)
    }
  }, [projects])

  useEffect(() => {
    if (projects.length === 0) {
      onFetchProjects()

      return
    }

    if (projectStatus === Status.idle || projectStatus === Status.loading)
      return null

    const currentPath = pathArray[pathArray.length - 1]

    if (containsPathProjectHome(currentPath)) {
      navigate(`/project/${projectId}/${currentPath}`)
    } else {
      navigate(`/project/${projectId}/home`)
    }
  }, [projectStatus])

  const onFetchProjects = () => {
    let fetchProjThunk = fetchProjectsByUserV2(validatedUser?.id)
    dispatch(fetchProjThunk)
  }

  return (
    <main className={classes.main}>
      <div className={classes.root}>
        {activeCountry && <DocumentsToolBar />}
        <div className={classes.container}>
          <div className={classes.sideNav}>
            <SideNaveV1 isProjectHome />
          </div>
          <div className={classes.body}>
            <Outlet />
          </div>
        </div>
      </div>
    </main>
  )
}

export default ProjectHomeV1
